<template>
  <div>
    <md-card>
      <md-card-content>
        <md-layout md-gutter>
          <md-layout md-flex="10">
            <md-button
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
              @click="previousVendorView"
            >&laquo; Back</md-button>
          </md-layout>
          <md-layout md-flex="30"></md-layout>
          <h2>Toll Charges</h2>
          <md-layout md-flex="10"></md-layout>
        </md-layout>

        <hr class="hr-s">

        <md-layout md-gutter class="mrgtop-2per">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="30">
            <md-input-container>
              <label>Pickup Location</label>
              <md-autocomplete
                id="pickUpLocation"
                name="pickUpLocation"
                v-model="toll.pickUpLocation"
                :list="masterList"
                printAttribute="pickupLocation"
                :filter-list="masterFilter"
                @selected="pickupLocationId"
              ></md-autocomplete>
            </md-input-container>
            <span class="error" v-if="!toll.pickUpLocation">{{pickUpLocationError}}</span>
          </md-layout>

          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="25">
            <md-input-container>
              <label>Stuffing Location</label>
              <md-autocomplete
                id="stuffingLocation"
                name="stuffingLocation"
                v-model="toll.stuffingLocation"
                :list="masterList"
                printAttribute="pickupLocation"
                :filter-list="masterFilter"
                @selected="stuffingLocationId"
              ></md-autocomplete>
            </md-input-container>
            <span class="error" v-if="!toll.stuffingLocation">{{stuffingLocationError}}</span>
          </md-layout>

          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="25">
            <md-input-container>
              <label>Handover Location</label>
              <md-autocomplete
                id="handoverLocation"
                name="handoverLocation"
                v-model="toll.handoverLocation"
                :list="masterList"
                printAttribute="pickupLocation"
                :filter-list="masterFilter"
                @selected="handoverLocationId"
              ></md-autocomplete>
            </md-input-container>
            <span class="error" v-if="!toll.handoverLocation">{{handoverLocationError}}</span>
          </md-layout>
        </md-layout>

        <md-layout md-gutter class="mrgtop-2per">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="30">
            <md-input-container>
              <label>Container Size</label>
              <md-autocomplete
                id="containerType"
                name="containerType"
                v-model="toll.containerType"
                :list="containerList"
                printAttribute="containerType"
                :filter-list="containermasterFilter"
                @selected="containerTypeId"
              ></md-autocomplete>
            </md-input-container>
            <span class="error" v-if="!toll.containerType">{{containerTypeError}}</span>
          </md-layout>

          <md-layout md-flex="5"></md-layout>
        </md-layout>

        <hr class="hr-border">

        <div class="box" v-if="allTollDetail.length>0">
          <div class="box-header">
            <h3 class="box-title">Toll Details(Single Way)</h3>
          </div>
          <!-- /.box-header -->
          <div class="box-body">
            <table id="vehicleTypeNew" class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Sr.no</th>
                  <th>Toll Name</th>
                  <th>Toll Charges(Single way)</th>

                  <th>Creation Date</th>
                  <th>Edit</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item1,index) in allTollDetail" :key="index">
                  <td>{{index+1}}</td>
                  <td>{{item1.tollName}}</td>
                  <td>{{item1.tollCharges}}</td>
                  <td>{{item1.loginTime | moment}}</td>
                  <td>
                    <md-button
                      class="md-icon-button md-raised md-dense"
                      @click="editTollNaka(item1)"
                    >
                      <md-icon>edit</md-icon>
                    </md-button>
                  </td>
                  <td>
                    <md-button
                      class="md-icon-button md-raised md-dense"
                      @click="deleteData(item1.tollNameChargesId)"
                    >
                      <md-icon>delete_sweep</md-icon>
                    </md-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- /.box-body -->
        </div>

        <md-layout md-gutter>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="15">
            <h3 style="margin-top:24px">Add TollName:</h3>
          </md-layout>
          <md-layout md-flex="30">
            <md-input-container>
              <label>Toll Name</label>
              <md-autocomplete
                id="tollName"
                name="tollName"
                v-model="addToll.tollName"
                :list="tollmasterList"
                printAttribute="tollName"
                :filter-list="tollmasterFilter"
                @selected="tollId"
              ></md-autocomplete>
            </md-input-container>
            <span class="error" v-if="!addToll.tollName">{{tollNameError}}</span>
          </md-layout>

          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="20">
            <md-layout md-flex="100">
              <label>Toll Charges(Single way)</label>
              <b-form-input :formatter="capitalizeAll"
                id="tollCharges"
                type="number"
                min="0"
                name="tollCharges"
                v-model="addToll.tollCharges"
              ></b-form-input>
            </md-layout>
            <span class="error" v-if="!addToll.tollCharges">{{tollChargesError}}</span>
          </md-layout>

          <md-layout md-flex="10"></md-layout>
          <md-layout md-flex="15" style="margin-top:1%">
            <md-button
              class="md-raised md-primary md-button-color heght-1px"
              @click="addTollNaka"
              id="addButtonLoader1"
            >{{addToll.tollNameChargesId==''?"Add":"Edit"}} Toll</md-button>
            <md-spinner md-indeterminate id="loader1" style="display:none"></md-spinner>
          </md-layout>
        </md-layout>
        <hr class="hr-border">

        <md-layout md-gutter>
          <md-layout md-flex="40">
            <span class="error" v-if="autoSuggestedLocation!=''">{{autoSuggestedLocation}}</span>
          </md-layout>
        </md-layout>

        <md-layout md-gutter class="mrgtop-2per">
          <md-layout md-flex="40"></md-layout>
          <md-layout md-flex="20">
            <md-button
              class="md-raised md-primary md-button-color heght-1px"
              @click="addVehicleType"
              id="addButtonLoader"
            >Submit</md-button>
            <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>
          </md-layout>
        </md-layout>

        <hr class="hr-s">
      </md-card-content>
    </md-card>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop1"
      @close="onClose1"
    ></md-dialog-alert>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
      @close="routetoview"
    ></md-dialog-alert>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose6"
      ref="addPop6"
    ></md-dialog-confirm>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../../helper/filters";
import axios from "axios";
import moment from "moment";
import { globalPermissionStatus } from "../../../helper/collection";

export default {
  beforeMount() {
    this.$store.dispatch("setCurrentRoute", "/vehicle/vehicleType");
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/departmentMaster/department/");
      if (globalPermissionStatus("vehicleMaster") != "Disabled") {
        this.$sessionsStorage.set(
          "PermissionStatus",
          globalPermissionStatus("vehicleMaster")
        );
      } else {
        this.$router.push({
          path: "/dashboard"
        });
      }

      this.getData();

      if (
        this.$sessionsStorage.get("editTollChargesId") != undefined &&
        this.$sessionsStorage.get("editTollChargesId") != ""
      ) {
        this.viewTollChargesId();
      }
    } else {
      this.$router.push({
        path: "/Login/"
      });
    }
  },
  data() {
    return {
      alert: {
        content: "Added Succesfully",
        ok: "ok"
      },

      addToll: {
        tollNameChargesId: "",
        tollName: "",
        tollCharges: "",
        tollId: ""
      },
      toll: {
        tollchargesId: "",
        alltollId: "",
        pickUpLocation: "",
        handoverLocation: "",
        stuffingLocation: "",
        containerType: "",
        pickupLocationId: "",
        stuffingLocationId: "",
        handoverLocationId: "",
        containerTypeId: ""
      },

      tollName: "",
      allTollDetail: [],
      getLocationData: ["agra"],
      getContainetList: ["agra"],
      getTollList: ["agra"],
      validate: true,
      pickUpLocationError: "",
      autoSuggestedLocation: "",
      handoverLocationError: "",
      stuffingLocationError: "",
      containerTypeError: "",
      tollChargesError: "",
      tollNameError: "",
      excelUpload: "",
      deleteId: ""
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date)
    }
  },

  mounted() {},
  beforeDestroy() {
    this.$sessionsStorage.set("editTollChargesId", "");
  },
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect
  },
  computed: {
    masterList() {
      return this.getLocationData;
    },

    containerList() {
      return this.getContainetList;
    },
    tollmasterList() {
      return this.getTollList;
    }
  },
  methods: {
    previousVendorView() {
      this.$router.push({
        path: "/toll/viewtollCharges"
      });
    },
    JqueryFun() {
      return $(function() {
        return $("#vehicleTypeNew").DataTable();
      });
    },
    routetoview() {
      this.$router.push({
        path: "/toll/viewtollcharges"
      });
    },

    validateAddVehicleTypeForm() {
      let validate_new = true;
      if (this.toll.pickUpLocation == "") {
        $("#pickUpLocation").focus();
        this.pickUpLocationError = "Please Select Location";
        validate_new = false;
      }

      if (this.toll.containerType == "") {
        $("#containerType").focus();
        this.containerTypeError = "Please Select Container Type";
        validate_new = false;
      }

      if (this.toll.stuffingLocation == "") {
        $("#stuffingLocation").focus();
        this.stuffingLocationError = "Please Select Location";
        validate_new = false;
      }

      if (this.toll.handoverLocation == "") {
        $("#handoverLocation").focus();
        this.handoverLocationError = "Please Select Location";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    onClose1(type) {
      let payload = {
        alltollId: this.toll.alltollId
      };
      if (this.toll.tollchargesId != "") {
        payload["tollchargesId"] = this.toll.tollchargesId;
      } else {
        payload["tollchargesId"] = "";
      }

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/viewTollNameCharges.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            if (data.allToll.length > 0) {
              this.allTollDetail = data.allToll;
              //  console.log("dfd", data.itemArray);
            }

            Object.keys(this.addToll).map(x => {
              this.addToll[x] = "";
            });
            (this.tollNameError = ""), (this.tollChargesError = "");
            this.JqueryFun();
            this.getData();
            //this.$refs["dialog"].open();
            // this.$refs["addPop1"].close();
          }
        })
        .catch(error => {});
    },

    validateTollNaka() {
      let validate_new = true;
      if (this.addToll.tollName == "") {
        $("#tollName").focus();
        this.tollNameError = "Please Select Toll Name";
        validate_new = false;
      }

      if (this.addToll.tollCharges == "") {
        $("#tollCharges").focus();
        this.tollChargesError = "Enter Toll Charges";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    tollId(item) {
      this.addToll.tollId = item.tollId;
    },
    addVehicleType() {
      this.validateAddVehicleTypeForm();

      if (this.toll.pickupLocationId == "" && this.toll.pickUpLocation != "") {
        this.autoSuggestedLocation =
          "Select Pickup Location From Auto suggested";

        return false;
      } else if (
        this.toll.handoverLocationId == "" &&
        this.toll.handoverLocation != ""
      ) {
        this.autoSuggestedLocation =
          "Select Handover Location From Auto suggested";
        return false;
      } else if (
        this.toll.stuffingLocationId == "" &&
        this.toll.stuffingLocation != ""
      ) {
        this.autoSuggestedLocation =
          "Select Handover Location From Auto suggested";
        return false;
      } else if (
        this.toll.containerTypeId == "" &&
        this.toll.containerType != ""
      ) {
        this.autoSuggestedLocation = "Select container From Auto suggested";
        return false;
      }

      if (this.validate != false) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");

        let new_Type_Data = {
          tollName: this.tollName
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Master/addTollCharges.php`,
          data: JSON.stringify(this.toll),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            $("#addButtonLoader").css("display", "block");
            $("#loader").css("display", "none");
            if (result.data.Id != "" && result.data.Id != undefined) {
              if (this.toll.tollchargesId == "") {
                this.alert.content = "Data Added Succesfully";
              } else {
                this.alert.content = "Data Updated Succesfully";
              }
              this.$refs["addPop"].open();

              this.getData();
              Object.keys(this.toll).map((x, index) => {
                this.toll[x] = "";
              });
            }
          })
          .catch(error => {});
      }
    },
    addTollNaka() {
      if (this.toll.tollchargesId != "") {
        this.addToll["tollChargesId"] = this.toll.tollchargesId;
      }

      // console.log(this.addToll);
      // return false;
      this.validateTollNaka();
      if (this.validate != false) {
        $("#addButtonLoader1").css("display", "none");
        $("#loader1").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Master/addTollNameCharges.php`,
          data: JSON.stringify(this.addToll),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            $("#addButtonLoader1").css("display", "block");
            $("#loader1").css("display", "none");
            if (result.data.Id != "" && result.data.Id != undefined) {
              if (this.addToll.tollNameChargesId == "") {
                this.alert.content = "Data Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
              }
              this.getData();
              this.toll.alltollId += result.data.Id + ",";

              this.$refs["addPop1"].open();
            }
          })
          .catch(error => {});
      }
    },

    viewTollChargesId() {
      let payload = {
        tollChargesMaster: "tollcharges",
        tollchargesId: this.$sessionsStorage.get("editTollChargesId")
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/viewTollCharges.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            // console.log(data);
            Object.keys(this.toll).map((x, index) => {
              this.toll[x] = data.tollChargesMaster[0][x] || "";
            });
            this.toll.alltollId = data.tollChargesMaster[0].alltollId + ",";
            this.showTollName(data.tollChargesMaster[0].alltollId);
            // this.getLocationData = data.locationMaster;
            // this.getContainetList = data.containerTypeMaster;
            // this.getTollList = data.tollMasterArray;
            this.JqueryFun();
          }
        })
        .catch(error => {});
    },

    showTollName(id) {
      let payload = {
        alltollId: id
      };

      payload["tollchargesId"] = "";

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/viewTollNameCharges.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            if (data.allToll.length > 0) {
              this.allTollDetail = data.allToll;
              //  console.log("dfd", data.itemArray);
            }

            this.JqueryFun();
            //this.$refs["dialog"].open();
            // this.$refs["addPop1"].close();
          }
        })
        .catch(error => {});
    },
    editTollNaka(item) {
      Object.keys(this.addToll).map((x, index) => {
        this.addToll[x] = item[x] || "";
      });
      $("#tollName").focus();
      window.scroll(0, 500);
    },
    getData() {
      let type_Size = {
        tollName: "tollName"
      };
      if (
        this.$sessionsStorage.get("editTollChargesId") != undefined &&
        this.$sessionsStorage.get("editTollChargesId") != ""
      ) {
        type_Size["tollchargesId"] = this.$sessionsStorage.get(
          "editTollChargesId"
        );
      }

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Transport/fetchtollData.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            this.getLocationData = data.locationMaster;
            this.getContainetList = data.containerTypeMaster;
            this.getTollList = data.tollMasterArray;
            this.JqueryFun();
          }
        })
        .catch(error => {});
    },

    masterFilter(list, query) {
      return this.getLocationData.filter(x => {
        return x.pickupLocation.toLowerCase().includes(query.toLowerCase());
      });
    },
    containermasterFilter(list, query) {
      return this.getContainetList.filter(x => {
        return x.containerType.toLowerCase().includes(query.toLowerCase());
      });
    },
    tollmasterFilter(list, query) {
      return this.getTollList.filter(x => {
        return x.tollName.toLowerCase().includes(query.toLowerCase());
      });
    },
    downloadExcel() {
      let excelName = {
        excelName: "DepartmentMaster",
        validExcel: "yes"
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/downloadMasterExcel.php`,
        data: JSON.stringify(excelName),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            // console.log(data);
            // console.log(data.link12);

            window.open(data.link12);
          }
        })
        .catch(error => {});
    },
    onFileChange() {
      var files = event.target.files || event.dataTransfer.files;
      // this.uploadCheck = files[0];
      var formData = new FormData();

      for (let i = 0; i < files.length; i++) {
        formData.append(`departmentMaster[]`, files[i]);
      }
      const config = {
        headers: { "content-type": "multipart/form-data" }
      };

      axios
        .post(`${URL_BASE}/uploadExcelDataMaster.php`, formData, config)
        .then(result => {
          console.log(result.data);
          if (result.data == "Only XLXS Format Support") {
            this.alert.content = "Only .xlxs format support";
          } else {
            this.alert.content = result.data;
          }
          this.$refs["addPop"].open();
          this.getData();
        })
        .catch(err => {
          throw err;
        });
    },
    deleteData(id) {
      this.deleteId = id;
      this.alert.content = "Are you sure you want to delete this data?";
      this.$refs["addPop6"].open();
    },

    pickupLocationId(item) {
      this.toll.pickupLocationId = item.pickupId;
    },
    stuffingLocationId(item) {
      this.toll.stuffingLocationId = item.pickupId;
    },
    handoverLocationId(item) {
      this.toll.handoverLocationId = item.pickupId;
    },
    containerTypeId(item) {
      this.toll.containerTypeId = item.containerTypeId;
    },
    onClose6(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "tollnamecharges",
          tableId: "tollNameChargesId",
          tableIsActive: "isActive",
          tableVal: this.deleteId
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/deletePermanent.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if (
              data.clientId != "" &&
              
              status == 200 &&
              data
            ) {
              this.JqueryFun();

              this.onClose1();
              // console.log(data);
            }
          })
          .catch(error => {});
      }
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// tollCharges.vue?5ad05c53